var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification is-info"},[(_vm.alert.message)?_c('div',{class:("alert " + (_vm.alert.type)),attrs:{"role":"alert","aria-live":"polite"}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }